import { render, staticRenderFns } from "./EnviarAvisos.vue?vue&type=template&id=5a111da0"
import script from "./EnviarAvisos.vue?vue&type=script&lang=js"
export * from "./EnviarAvisos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports